import { EnterpriseScopeCounterDiscriminator } from '@mews-commander/data-access';
import { usePrivilege } from '@mews-commander/core';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { NonSystemCounterType, openCreateCounterDialog } from '../actions';
import { useCanAddOrResetCounters } from '../utils';
import { CountersTable } from './CountersTable';
import { CreateCounterDialog } from './CreateCounterDialog';
import { noteCounterColumnMapping } from './tableMapping';

interface GeneralCountersTableProps {
    counterTypes: EnterpriseScopeCounterDiscriminator[];
    isSystemGenerated?: boolean;
}

type SupportedCounterTypes = Exclude<NonSystemCounterType, EnterpriseScopeCounterDiscriminator.CreditNoteBillCounter>;

export const GeneralCountersTable = ({ counterTypes, isSystemGenerated }: GeneralCountersTableProps) => {
    const counterType = counterTypes[0] as SupportedCounterTypes;
    const dispatch = useCommanderThunkDispatch();
    const openDialog = () => {
        dispatch(openCreateCounterDialog(counterType));
    };

    const canManageCounters = usePrivilege('manageCounters');
    const canAddOrResetCounters = useCanAddOrResetCounters();
    const canAddCounters = !isSystemGenerated && canManageCounters && canAddOrResetCounters;

    return (
        <>
            <CountersTable
                counterTypes={counterTypes}
                tableColumns={noteCounterColumnMapping}
                openDialog={openDialog}
                showAddButton={canAddCounters}
            />
            <CreateCounterDialog type={counterType} />
        </>
    );
};
